export default {"src":"/_next/static/media/responsive.daf3c8d2.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};